import React, { memo } from 'react'
import { useSelector } from 'react-redux';
import { Redirect, Route } from "react-router-dom";
import paths from '../helper/pathRoutes';
import { selectIsLogged } from '../modules/auth/redux';

function PrivateRouter({ component: Component, ...restOfProps }) {
  const isAuthenticated = useSelector(selectIsLogged);

  return (
    <Route
      {...restOfProps}
      render={(props) => {
        // 1. 未ログインの場合はログイン画面へ強制リダイレクト
        if (!isAuthenticated) {
          return <Redirect to={paths.login} />;
        }

        // 2. ログイン済みの場合のMFA直叩きガード
        const currentPath = props.location.pathname;
        const isMfaPath = currentPath === paths.mfa || 
                           currentPath === paths.mfaSms || 
                           currentPath === paths.mfaMail;

        if (isMfaPath) {
          // ログイン画面や確認画面から正規に遷移してきたときの「from」の足跡を確認します
          // 例：login画面から歴史を持って history.push({ pathname: paths.mfa, state: { from: 'profile_submit' } }) などで来た場合
          const hasReferrer = props.location.state?.from;

          // 正常な画面遷移（足跡あり）のとき、またはMFA画面でのブラウザ更新（更新時はstateが一時的に維持される、または空でも直叩きではないため許容）のときは、そのままMFA画面を表示します。
          // すでにログインが完了してマイページ等にいる状態から、URLを直に入力してアクセスしてきた（足跡が一切ない）場合のみ、マイページへ引き戻します。
          if (!hasReferrer && props.history.action === 'POP' && !props.location.key) {
            return <Redirect to={paths.myPoint || '/mypage'} />;
          }
        }

        // 3. 通常の認証画面（マイページ、確認・変更など）はそのまま表示
        return <Component {...props} />;
      }}
    />
  );
}

export default memo(PrivateRouter);